import { useEffect, useState } from "react";
import { ArrowUp } from "@phosphor-icons/react";

// Appears once the user has scrolled down more than one viewport height,
// so it's reachable without hunting for it on short pages.
export const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible((was) => {
        const past = window.scrollY > window.innerHeight;
        return was === past ? was : past; // skip re-render when the threshold hasn't flipped
      });
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="scroll-to-top-btn"
      aria-label="Yuxarı qayıt"
      title="Yuxarı qayıt"
      className="fixed  bottom-[90px] sm:bottom-14 right-6 z-30 w-11 h-11 rounded-full bg-primary text-primary-foreground shadow-lg flex items-center justify-center hover:bg-primary/90 hover:-translate-y-0.5 transition-all"
    >
      <ArrowUp size={18} weight="bold" />
    </button>
  );
};
